export var FundedOption;
(function (FundedOption) {
    FundedOption["TOTALLY_FUNDED"] = "totally_funded";
    FundedOption["PARTIALLY_FUNDED"] = "partially_funded";
    FundedOption["NOT_FUNDED"] = "not_funded";
})(FundedOption || (FundedOption = {}));
